import { createContext, useContext } from "react";

// Crea el contexto de autenticación
const AuthContext = createContext(null);

// Hook personalizado para consumir el contexto más fácilmente
export const useAuth = () => useContext(AuthContext);

export default AuthContext;
